import React from 'react';
import { useTranslation } from 'react-i18next';
import CounterUp from './CounterUp';

const StatSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-gray-900 dark:bg-gray-800 text-white py-10">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Clients */}
          <CounterUp start={0} end={10} duration={2000} title={t('client')} />

          {/* Teams members */}
          <CounterUp start={0} end={7} duration={2000} title={t('Workers')} />

          {/* Projects */}
          <CounterUp start={0} end={20} duration={2000} title={t('projet')} />

          {/* Experiences */}
          <CounterUp start={0} end={3} duration={2000} title={t('experience')} />
        </div>
      </div>
    </section>
  );
};

export default StatSection;
